import "./form.scss";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import axios from "axios";
import { Alert, FormControlLabel, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Form() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  // Alert
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const url = "https://dev.pmwevents.com";
  const navigate = useNavigate();

  const handleForm = () => {
    const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const phoneRegex = /^[0-9]*$/;

    if (firstName === "" || lastName === "" || phone === "" || email === "") {
      setMessage("All fields are required");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else if (!email.match(regex)) {
      setMessage("Email is the wrong format");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else if (!phone.match(phoneRegex)) {
      setMessage("Please insert your phone with only numbers");
      setSeverity("warning");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 2000);
    } else {
      let data = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
      };

      axios
        .post(`${url}/sbc/waiting-list`, data)
        .then((res) => {
          navigate(`/thank-you`);
        })
        .catch((err) => {
          console.log(err);
          setMessage("something went wrong, please try again");
          setSeverity("error");
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 2000);
        });
    }
  };

  return (
    <section className="waitlist">
      <h3>Join The Priority List</h3>

      <input
        type="text"
        placeholder="First Name"
        className="custom-input"
        onChange={(e) => setFirstName(e.target.value)}
      />
      <input
        type="text"
        placeholder="Last Name"
        className="custom-input"
        onChange={(e) => setLastName(e.target.value)}
      />
      <input
        type="email"
        placeholder="Email"
        className="custom-input"
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="tel"
        placeholder="Phone Number"
        pattern="[0-9]*"
        className="custom-input"
        onChange={(e) => setPhone(e.target.value)}
      />

      <FormControlLabel
        control={
          <Checkbox
            sx={{
              color: "black",
              "&.Mui-checked": {
                color: "black",
              },
              "& .MuiSvgIcon-root": {
                borderRadius: "2px",
              },
            }}
            onChange={(e) => setConsent(e.target.checked)}
          />
        }
        label="Yes, I give permission for Paul McFadden Wealth to send me communications about events and anything related that they may deem relevant as in accordance with their privacy policy "
        className="check--box"
      />

      {showAlert ? (
        <Alert severity={severity} width="80%">
          {message}
        </Alert>
      ) : (
        <button className="form-btn" disabled={!consent} onClick={handleForm}>
          Join The Priority List
        </button>
      )}
    </section>
  );
}
